import React from 'react'

import confirmEmail from 'assets/image/confirm-email.svg'

const ForgotPasswordEmail = () => {
  return (
    <div className="max-w-[800px] px-8 py-[53px] mx-auto w-full flex flex-col items-center justify-start !text-white-50">
      <h3 className="text-5xl font-bold !mb-3">Confirm Email</h3>

      <p className="text-center mb-16 text-xl">
        Please check your inbox. We have sent a reset link
      </p>

      <div>
        <img className="block" src={confirmEmail} alt="Confirm email" />
      </div>
    </div>
  )
}

export default ForgotPasswordEmail
